import React from 'react'
import { Route, Switch } from 'react-router-dom'
import swal from 'sweetalert'
import Api from '../../../utils/api'
import NewsEditPage from './edit'
import { bindActionCreators } from 'redux'
import { push } from "connected-react-router"
import { connect } from 'react-redux'
import NewsMainPage from './main'

class News extends React.Component {

  constructor (props) {
    super(props);

    this.state = {
      data: []
    };
  }

  componentWillMount = () => {
    this.updateNews();
  }

  updateNews = () => {
    Api.get('/news')
      .then(data => {
        this.setState({ data: data.value || [] });
      });
  }

  onEdit = (data, isEdit = false, id = 0) => {
    let form = new FormData(),
      dataKeys = Object.keys(data.data);

    for(let i=0; i<dataKeys.length; i++) {
      form.append(dataKeys[i], data.data[dataKeys[i]]);
    }

    let query;
    if(isEdit) {
      query = Api.put('/news/' + id, form);
    }
    else {
      query = Api.post('/news', form);
    }

    query.then(out => {
        this.props.changePage('/news');
        swal({ title: "Успешно", icon: "success", button: "Ок" });
      })
      .catch(() => {
        swal({ title: "Произошла ошибка", icon: "error", button: "Ок" });
      });
  }

  render = () => {
    let location = this.props.location;

    return (
      <div>
        <Switch location={location}>
          <Route path="/news/create" component={() => <NewsEditPage onEdit={this.onEdit}/>} />
          { this.props.news.data.id && this.props.user.isAdmin === 1 && <Route path="/news/edit" component={() => <NewsEditPage isEdit={true} onEdit={this.onEdit}/>} /> }
          <Route path="/news" component={() => <NewsMainPage updateNews={this.updateNews} data={this.state.data}/>} />
        </Switch>
      </div>
    )
  }

}

const mapStateToProps = ({ user, news }) => ({
  user,
  news
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changePage: (page) => push(page)
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(News)
